@if (grundstueck) {
  @if (grundstueck) {
    <div class="row mt-2">
      <div class="col-md-6 col-sm-12">
        <cap-kopfdatenelement [histInfo]="grundstueck.histInfo" label="Gemeinde">
          {{ gsNummerEntry.gbGemeinde?.name | translateName }}, {{ gsNummerEntry.gbGemeinde.bfsNummer }}
          @if (gsNummerEntry.gbGemeinde.kreisNummer) {
            <span>.{{ gsNummerEntry.gbGemeinde.kreisNummer }}</span>
          }
        </cap-kopfdatenelement>
        <cap-kopfdatenelement [histInfo]="grundstueck.histInfo" label="GrundstueckNummer">
          {{ gsNummer }}
        </cap-kopfdatenelement>
        <cap-kopfdatenelement [histInfo]="grundstueck.histInfo" label="Grundstuecksart">
          {{ grundstueck?.grundstueckArt | translate }}
        </cap-kopfdatenelement>
        <cap-kopfdatenelement [histInfo]="grundstueck?.histInfo" label="EGRID">
          @if (grundstueck.egrid) {
            <span>
              {{ grundstueck.egrid.value }}
            </span>
          }
        </cap-kopfdatenelement>
      </div>
      <div class="col-md-6 col-sm-12">
        <cap-kopfdatenelement [histInfo]="grundstueck.histInfo" label="Grundbuchtyp">
          {{ gsNummerEntry.gbGemeinde.grundbuchFuehrung | translate }}
        </cap-kopfdatenelement>
        <cap-kopfdatenelement [histInfo]="grundstueck.histInfo" label="FormDerFuehrung">
          {{ grundstueck.grundbuchFuehrung | translate }}
          @if (grundstueck.eidgenoessischSeit) {
            {{ "seit" | translate }}
            {{ grundstueck.eidgenoessischSeit | datum }}
          }
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="ErstelltMit">
          <cap-kompakt-timepoint [item]="grundstueck.histInfo.vonTimePoint" format="TIMEPOINT_TYP01"></cap-kompakt-timepoint>
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="GestrichenMit">
          <cap-kompakt-timepoint [item]="grundstueck.histInfo.bisTimePoint" format="TIMEPOINT_TYP01"></cap-kompakt-timepoint>
        </cap-kopfdatenelement>
      </div>
    </div>
  }
  @if (grundstueck.grundstueckArt === "LIEGENSCHAFT" || grundstueck.grundstueckArt === "SDR") {
    <span>
      <cap-grundstueckflaeche
        [anzeigenAusSichtGeschaeft]="true"
        [grundstueckId]="_grundstueckId"
        [hasRight]="grundstueck.permissions?.beschreibung"
        [isMeldung]="true"></cap-grundstueckflaeche>
      <cap-gebaeude
        [anzeigenAusSichtGeschaeft]="true"
        [grundstueckId]="_grundstueckId"
        [hasRight]="grundstueck.permissions?.beschreibung"
        [isMeldung]="true"></cap-gebaeude>
    </span>
  }
  @if (grundstueck.grundstueckArt === "STOCKWERK" || grundstueck.grundstueckArt === "MITEIGENTUM") {
    <cap-stammgrundstueck [grundstueckId]="_grundstueckId"></cap-stammgrundstueck>
  }
  @if (grundstueck.grundstueckArt === "STOCKWERK") {
    <cap-sonderrecht [anzeigenHistorischeDaten]="false" [grundstueckId]="_grundstueckId" [hasRight]="grundstueck.permissions?.beschreibung">
    </cap-sonderrecht>
  }
  <cap-dominierte-grundstuecke
    [anzeigenAusSichtMeldung]="true"
    [grundstueckId]="_grundstueckId"
    [hasRight]="grundstueck.permissions?.beschreibung && hasPermissionDominierteGrundstuecke">
  </cap-dominierte-grundstuecke>
  @if (grundstueck && grundstueck.grundstueckArt === "SDR") {
    <span>
      <cap-beschreibung-table-wrapper [tableFullWidth]="false" class="my-2">
        <span class="cap-table-wrapper-title" style="font-weight: bold">
          {{ "SelbststaendigUndDauerndeRechte" | translate }}
        </span>
        <ng-container class="cap-table-wrapper-content">
          <cap-standardrecht-table
            [hasRight]="grundstueck.permissions?.beschreibung && dienstbarkeitErsterfassungUebergeben"
            [listLoader]="sdrDienstbarkeitLoader">
          </cap-standardrecht-table>
        </ng-container>
      </cap-beschreibung-table-wrapper>
    </span>
  }
  @if (grundstueck.grundstueckArt === "FOLIO") {
    <cap-kuhrecht [anzeigenHistorischeDaten]="false" [grundstueckId]="_grundstueckId" [hasRight]="grundstueck.permissions?.beschreibung">
    </cap-kuhrecht>
  }
  @if (grundstueck.grundstueckArt === "FOLIO") {
    <cap-alpgrundstuecke
      [anzeigenHistorischeDaten]="false"
      [grundstueckId]="_grundstueckId"
      [hasRight]="grundstueck.permissions?.beschreibung">
    </cap-alpgrundstuecke>
  }
  <cap-beschreibung-table-wrapper [tableFullWidth]="false" class="my-2">
    <span class="cap-table-wrapper-title" style="font-weight: bold">
      {{ "Eigentum" | translate }}
    </span>
    <ng-container class="cap-table-wrapper-content">
      <cap-eigentum-table
        [hasRight]="grundstueck.permissions?.eigentum && eigentumErsterfassungUebergeben"
        [listLoader]="eigentumLoader"
        [showAdressen]="false"
        [showHistorischeDaten]="false">
      </cap-eigentum-table>
    </ng-container>
  </cap-beschreibung-table-wrapper>
  <cap-grundstueck-bemerkung
    [anzeigenHistorischeDaten]="false"
    [grundstueckId]="_grundstueckId"
    [hasRight]="grundstueck.permissions?.beschreibung"
    [isMeldung]="true">
  </cap-grundstueck-bemerkung>
}
